// Per-product overrides for photos whose alt text doesn't match the actual color visible.
// Format: { "<product-handle>": { "<media-id>": "<actual color lowercased>" } }
const MEDIA_COLOR_OVERRIDES_MOBILE = {
  "augusta-bag": {
    "56650888642931": "black",
    "56667924038003": "black",
  },
  "coral-bucket-bag": {
    "56667938521459": "sagefield",
    "56554722296179": "sagefield",
    "56667946844531": "sagefield",
    "54518857728371": "sagefield",
    "54518857761139": "sagefield",
    "56667960312179": "shiraz",
    "56667952513395": "shiraz",
    "54518846882163": "shiraz",
  },
};

if (!customElements.get("media-gallery-mobile")) {
  customElements.define(
    "media-gallery-mobile",
    class MediaGalleryMobile extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          container: ".m-main-product--wrapper",
          slider: ".swiper-container",
          sliderPagination: ".swiper-pagination",
          sliderPrevEl: ".swiper-button-prev",
          sliderNextEl: ".swiper-button-next",
          navSlider: ".nav-swiper-container",
          medias: [".m-product-media--item"],
          mediaWrapper: ".m-product-media--wrapper",
          mediaZoomIns: [".m-product-media__zoom-in"],
          videos: [".media-video"],
          variantIdNode: '[name="id"]',
          featuredImage: ".m-product-media",
        };

        this.container = this.closest(this.selectors.container);
        this.domNodes = queryDomNodes(this.selectors, this);
        this.enableVideoAutoplay = this.dataset.enableVideoAutoplay === "true";
        this.enableImageZoom = this.dataset.enableImageZoom === "true";
        this.enableVariantGroupImages = this.dataset.enableVariantGroupImages === "true";
        this.onlyMedia = this.dataset.onlyMedia === "true";
        if (this.container) {
          this.view = this.container.dataset.view || "product-template";
        }
        this.section = this.closest(`[data-section-id="${this.sectionId}"]`);
        this.layout = this.dataset.layout;
      }

      connectedCallback() {
        this.setupData();
      }

      async setupData() {
        this.productHandle = this.dataset.productHandle;
        this.productUrl = this.dataset.productUrl;
        this.productData = await this.getProductJson(this.productUrl);

        const { productData, productData: { variants } = {} } = this;
        const variantIdNode = this.container.querySelector(this.selectors.variantIdNode);

        if (productData && variantIdNode) {
          let currentVariantId = Number(variantIdNode.value);
          if (!currentVariantId) {
            currentVariantId = productData.selected_or_first_available_variant.id;
          }
          const currentVariant = variants.find((v) => v.id === currentVariantId) || variants[0];
          this.productData.initialVariant = currentVariant;
          if (!this.productData.selected_variant && variantIdNode.dataset.selectedVariant) {
            this.productData.selected_variant = variants.find(
              (v) => v.id === Number(variantIdNode.dataset.selectedVariant)
            );
          }
          this.filterSlidesForVariant(currentVariant);
          this.init();
        }
      }

      filterSlidesForVariant(variant) {
        if (!variant || this.enableVariantGroupImages) return;

        const opts = (this.productData && this.productData.options) || [];
        const colorOption = opts.find((o) => /colou?r/i.test(o.name)) || opts[0];
        if (!colorOption) return;
        const colorIdx = (colorOption.position || 1) - 1;
        const variantOptions = variant.options || [];
        const colorValueRaw = (variantOptions[colorIdx] || variant.option1 || variantOptions[0] || "").trim();
        if (!colorValueRaw) return;
        const colorValue = colorValueRaw.toLowerCase();

        const allColors = (colorOption.values || []).map((v) => v.toLowerCase());
        const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const colorRegexes = {};
        allColors.forEach((c) => { colorRegexes[c] = new RegExp("\\b" + escapeRe(c) + "\\b", "i"); });

        const overridesForProduct = MEDIA_COLOR_OVERRIDES_MOBILE[this.productHandle] || {};

        if (!this._slidePool) {
          this._slidePool = document.createElement("div");
          this._slidePool.hidden = true;
          this._slidePool.setAttribute("aria-hidden", "true");
          this._slidePool.dataset.variantSlidePool = "true";
          this._slidePool.style.display = "none";
          this.appendChild(this._slidePool);
        }

        const wrapper = this.querySelector(".swiper-wrapper");
        if (!wrapper) return;

        const all = [];
        wrapper.querySelectorAll(".m-product-media--item").forEach((s) => all.push(s));
        this._slidePool.querySelectorAll(".m-product-media--item").forEach((s) => all.push(s));

        const getMediaId = (s) => {
          const inner = s.querySelector(".m-product-media");
          return (
            (s.dataset && s.dataset.mediaId) ||
            (inner && (inner.dataset.mediaId || inner.getAttribute("data-media-id"))) ||
            ""
          );
        };

        const resolveColor = (s) => {
          const mid = String(getMediaId(s));
          if (overridesForProduct[mid]) return overridesForProduct[mid].toLowerCase();
          const img = s.querySelector("img");
          const mediaEl = s.querySelector(".m-product-media");
          const alt = (
            (img && img.alt) ||
            (mediaEl && (mediaEl.dataset.mediaAlt || mediaEl.getAttribute("data-media-alt"))) ||
            ""
          ).toLowerCase();
          for (const c of allColors) {
            if (colorRegexes[c].test(alt)) return c;
          }
          return "neutral";
        };

        const matching = [];
        const nonMatching = [];
        all.forEach((s) => {
          if (s.classList && s.classList.contains("swiper-slide-duplicate")) {
            nonMatching.push(s);
            return;
          }
          const photoColor = resolveColor(s);
          if (photoColor === colorValue || photoColor === "neutral") matching.push(s);
          else nonMatching.push(s);
        });

        if (matching.length === 0) {
          all.forEach((s) => {
            if (!(s.classList && s.classList.contains("swiper-slide-duplicate"))) matching.push(s);
          });
        }

        matching.forEach((s) => { if (s.parentNode !== wrapper) wrapper.appendChild(s); });
        nonMatching.forEach((s) => { if (s.parentNode !== this._slidePool) this._slidePool.appendChild(s); });

        this._lastFilterColor = colorValue;
      }

      init() {
        const variantPicker = this.container.querySelector("variant-picker");
        this.handlePhotoswipe();
        this.initPhotoswipe();
        this.initSlider();

        this.handleAutoplayVideo();

        if (!variantPicker) {
          this.initPhotoswipe();
          this.handleSlideChange();
          this.removeAttribute("data-media-loading");
          this.firstElementChild.style.opacity = 1;
        }
      }

      initSlider() {
        if (!this.domNodes.slider) return;
        this.mediaMode = "slider";
        const {
          domNodes: { slider, sliderPagination, navSlider, sliderNextEl: nextEl, sliderPrevEl: prevEl },
        } = this;
        let initialSlide = -1,
          configNav = {},
          config = {};

        const variantItems = slider.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)");
        const initialVariant = this.productData.initialVariant;

        const normSrc = (s) => {
          if (!s) return "";
          return s.split("?")[0].replace(/^https?:/, "").replace(/_\d+x\d*\.([a-z]+)$/i, ".$1");
        };

        if (initialVariant && initialVariant.featured_media && initialVariant.featured_media.id && variantItems.length) {
          const wantedId = String(initialVariant.featured_media.id);
          for (let i = 0; i < variantItems.length; i++) {
            const mid = variantItems[i].dataset.mediaId || variantItems[i].getAttribute("data-media-id");
            if (mid && String(mid) === wantedId) { initialSlide = i; break; }
          }
        }

        if (initialSlide === -1 && initialVariant && initialVariant.featured_image && initialVariant.featured_image.src && variantItems.length) {
          const wantedSrc = normSrc(initialVariant.featured_image.src);
          for (let i = 0; i < variantItems.length; i++) {
            const mediaEl = variantItems[i].querySelector(".m-product-media");
            const dataSrc = mediaEl && (mediaEl.dataset.mediaSrc || mediaEl.getAttribute("data-media-src"));
            const img = variantItems[i].querySelector("img");
            const imgSrc = img && (img.currentSrc || img.src || img.dataset.src || img.getAttribute("src") || "");
            const candidates = [dataSrc, imgSrc].filter(Boolean).map(normSrc);
            if (candidates.some((c) => c && (c === wantedSrc || c.indexOf(wantedSrc) !== -1 || wantedSrc.indexOf(c) !== -1))) {
              initialSlide = i;
              break;
            }
          }
        }

        if (initialSlide === -1) {
          if (this.enableVariantGroupImages || !initialVariant || !initialVariant.featured_media || !variantItems.length) {
            initialSlide = 0;
          } else {
            const raw = (initialVariant.featured_media.position || 1) - 1;
            initialSlide = Math.max(0, Math.min(raw, variantItems.length - 1));
          }
        }

        configNav = {
          loop: false,
          initialSlide,
          slidesPerView: 5,
          freeMode: true,
          spaceBetween: 10,
          threshold: 2,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          on: {
            init: () => (navSlider.style.opacity = 1),
          },
        };

        this.navSlider = navSlider ? new MinimogLibs.Swiper(navSlider, configNav) : null;
        const thumbs = this.navSlider ? { thumbs: { swiper: this.navSlider } } : {};

        config = {
          initialSlide,
          autoHeight: true,
          navigation: { nextEl, prevEl },
          threshold: 2,
          loop: false,
          pagination: { el: sliderPagination, clickable: true, type: "bullets" },
          ...thumbs,
          on: {
            init: () => {
              slider.style.opacity = 1;
              this.domNodes = queryDomNodes(this.selectors, this.container);
            },
          },
        };

        this.slider = new MinimogLibs.Swiper(slider, config);

        if (!this.enableVariantGroupImages) this.handleSlideChange();
      }

      handleSlideChange() {
        if (!this.slider) return;
        let draggable = true,
          mediaType = "",
          visibleSlides = [];

        this.slider.on("slideChange", (swiper) => {
          window.pauseAllMedia(this);
          try {
            const { slides, activeIndex } = swiper;
            if (slides[activeIndex]) this.playActiveMedia(slides[activeIndex]);

            visibleSlides = [activeIndex];

            for (let index of visibleSlides) {
              const currSlide = slides[index];
              if (currSlide) {
                mediaType = currSlide.dataset.mediaType;
              }
              if (mediaType === "model") break;
            }

            if (mediaType === "model") {
              this.slider.allowTouchMove = false;
              draggable = false;
            } else {
              if (!draggable) this.slider.allowTouchMove = true;
              draggable = true;
            }
          } catch (error) {
            console.error("Failed to execute slideChange event.", error);
          }
        });
      }

      handleAutoplayVideo() {
        if (this.slider) {
          const { slides, activeIndex } = this.slider;
          const slideActive = slides[activeIndex];
          const firstElmMediaType = slideActive && slideActive.dataset.mediaType;

          if (firstElmMediaType === "video" || firstElmMediaType == "external_video") {
            const deferredMedia = slideActive.querySelector("deferred-media");
            const autoplay = deferredMedia.dataset.autoPlay === "true";
            if (deferredMedia && autoplay) deferredMedia.loadContent(false);
          }
        } else {
          const allMedia = this.querySelectorAll(".m-product-media--item");
          if (allMedia) {
            allMedia.forEach((media) => {
              const mediaType = media.dataset.mediaType;
              if (mediaType === "video" || mediaType === "external_video") {
                const deferredMedia = media.querySelector("deferred-media");
                const autoplay = deferredMedia.dataset.autoPlay === "true";
                if (deferredMedia && autoplay) deferredMedia.loadContent(false);
              }
            });
          }
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector("deferred-media");
        if (!deferredMedia) return;
        const autoplay = deferredMedia.dataset.autoPlay === "true";
        if (!autoplay) return;
        if (!deferredMedia.getAttribute("loaded")) {
          deferredMedia.loadContent(false);
          const deferredElement = deferredMedia.querySelector("video, model-viewer, iframe");
          if (deferredElement.classList.contains("js-youtube")) {
            const symbol = deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            deferredElement.src += symbol + "autoplay=1&mute=1";
          } else if (deferredElement.classList.contains("js-vimeo")) {
            const symbol = deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            deferredElement.src += symbol + "autoplay=1&muted=1";
          } else {
            deferredElement.play();
          }
        } else {
          const deferredElement = deferredMedia.querySelector("video, model-viewer, iframe");
          if (deferredElement.classList.contains("js-youtube")) {
            const symbol = deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            deferredElement.src += symbol + "autoplay=1&mute=1";
          } else if (deferredElement.classList.contains("js-vimeo")) {
            const symbol = deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            deferredElement.src += symbol + "autoplay=1&muted=1";
          } else {
            deferredElement.play();
          }
        }
      }

      handlePhotoswipe(customData = []) {
        if (!this.enableImageZoom) return;
        const data = [];
        const medias = this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)");

        if (medias) {
          medias.forEach((media, index) => {
            if (media.dataset.mediaType === "image") {
              const mediaDataItem = media.querySelector(".m-product-media");
              const mediaData = mediaDataItem.dataset;
              data.push({
                src: mediaData.mediaSrc,
                width: parseInt(mediaData.mediaWidth),
                height: parseInt(mediaData.mediaHeight),
                alt: mediaData.mediaAlt,
                id: media.dataset.index,
              });
            } else {
              data.push({
                html: `<div class="pswp__${media.dataset.mediaType}">${media.innerHTML}</div>`,
                type: media.dataset.mediaType,
                id: media.dataset.index,
              });
            }
          });
        }

        this.lightbox = new MinimogLibs.PhotoSwipeLightbox({
          dataSource: customData.length > 0 ? customData : data,
          bgOpacity: 1,
          close: false,
          zoom: false,
          arrowNext: false,
          arrowPrev: false,
          counter: false,
          preloader: false,
          pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe,
        });

        this.lightbox.addFilter("thumbEl", (thumbEl, data, index) => {
          const el = this.querySelector('[data-index="' + data.id + '"]:not(.swiper-slide-duplicate) img');
          if (el) {
            return el;
          }
          return thumbEl;
        });

        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, slide) => {
          const el = this.querySelector('[data-index="' + slide.data.id + '"]:not(.swiper-slide-duplicate) img');
          if (el) {
            return el.src;
          }
          return placeholderSrc;
        });

        this.lightbox.on("change", () => {
          window.pauseAllMedia(this);
          if (this.slider) {
            const currIndex = this.lightbox.pswp.currIndex;
            this.slider.slideTo(currIndex, 100, false);
          }
        });

        this.lightbox.on("pointerDown", (e) => {
          const currSlide = this.lightbox.pswp.currSlide.data;
          if (currSlide.type === "model") {
            e.preventDefault();
          }
        });

        const closeBtn = {
          name: "m-close",
          order: 11,
          isButton: true,
          html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
          onClick: (event, el, pswp) => {
            pswp.close();
          },
        };
        const arrowNext = {
          name: "m-arrowNext",
          className: "sf-pswp-button--arrow-next",
          order: 12,
          isButton: true,
          html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
          onClick: (event, el, pswp) => {
            pswp.next();
          },
        };
        const arrowPrev = {
          name: "m-arrowPrev",
          className: "sf-pswp-button--arrow-prev",
          order: 10,
          isButton: true,
          html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
          onClick: (event, el, pswp) => {
            pswp.prev();
          },
        };

        this.lightbox.on("uiRegister", () => {
          this.lightbox.pswp.ui.registerElement(closeBtn);
          if (!this.onlyMedia) {
            this.lightbox.pswp.ui.registerElement(arrowPrev);
            this.lightbox.pswp.ui.registerElement(arrowNext);
          }
        });
      }

      initPhotoswipe() {
        if (!this.enableImageZoom) return;
        this.lightbox.init();
        addEventDelegate({
          selector: this.selectors.medias[0],
          context: this,
          handler: (e, media) => {
            e.preventDefault();
            const isImage = media.classList.contains("media-type-image");
            const isZoomButton = e.target.closest(this.selectors.mediaZoomIns[0]);
            if (isImage || isZoomButton) {
              const index = Number(media.dataset.index) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      setActiveMedia(variant) {
        if (!variant) return;

        this.filterSlidesForVariant(variant);

        if (this.slider) {
          try { this.slider.destroy(true, true); } catch (e) {}
          this.slider = null;
        }
        if (this.navSlider) {
          try { this.navSlider.destroy(true, true); } catch (e) {}
          this.navSlider = null;
        }

        const wrapper = this.querySelector(".swiper-wrapper");
        if (wrapper) {
          wrapper.style.transitionDuration = "0ms";
          wrapper.style.transform = "";
        }

        this.initSlider();
      }

      scrollIntoView(selectedMedia) {
        selectedMedia.scrollIntoView({
          behavior: "smooth",
        });
      }

      getProductJson(productUrl) {
        return fetch(productUrl + ".js")
          .then((response) => {
            if (!response.ok) {
              const productData = JSON.parse(
                this.container.querySelector("#productData[type='application/json']").textContent
              );
              return productData;
            } else {
              return response.json();
            }
          })
          .catch((err) => console.log(err));
      }
    }
  );
}
